import { apiClient } from '@/api/client'
import {
  ROLES,
  ROLES_PERMISSIONS_ALL,
  ROLES_TEMPLATES,
  rolePermissionsPath,
} from '@/api/endpoints'
import type {
  AssignPermissionsPayload,
  CreateRolePayload,
  Permission,
  Role,
  RoleTemplate,
  UpdateRolePayload,
} from '@/types'

export async function getRoles(): Promise<Role[]> {
  const { data } = await apiClient.get<{ data?: Role[] } | Role[]>(ROLES)
  return Array.isArray(data) ? data : data?.data ?? []
}

export async function getAllPermissions(): Promise<Permission[]> {
  const { data } = await apiClient.get<{ data?: Permission[] }>(ROLES_PERMISSIONS_ALL)
  const list = Array.isArray(data) ? data : data?.data
  return list ?? []
}

export async function getRoleTemplates(): Promise<RoleTemplate[]> {
  const { data } = await apiClient.get<{ data?: RoleTemplate[] } | RoleTemplate[]>(
    ROLES_TEMPLATES
  )
  return Array.isArray(data) ? data : data?.data ?? []
}

export async function createRole(payload: CreateRolePayload): Promise<Role> {
  const { data } = await apiClient.post<Role>(ROLES, payload)
  return data
}

export async function cloneRole(id: string, name: string): Promise<Role> {
  const { data } = await apiClient.post<Role>(`${ROLES}/${id}/clone`, { name })
  return data
}

export async function updateRole(id: string, payload: UpdateRolePayload): Promise<Role> {
  const { data } = await apiClient.put<Role>(`${ROLES}/${id}`, payload)
  return data
}

export async function updateRolePermissions(
  roleId: string,
  payload: AssignPermissionsPayload
): Promise<Role> {
  const body: AssignPermissionsPayload = {
    permissions: payload.permissions.map(({ module, actions }) => ({
      module,
      actions: [...actions],
    })),
  }
  const { data } = await apiClient.put<{ data?: Role } | Role>(
    rolePermissionsPath(roleId),
    body
  )
  const resolved = data as { data?: Role }
  return resolved?.data ?? (data as Role)
}

export async function deleteRole(id: string): Promise<void> {
  await apiClient.delete(`${ROLES}/${id}`)
}
